import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

import NavigationBar from '../../components/ui/NavigationBar';
import FloatingNavigation from '../../components/ui/FloatingNavigation';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import FloatingCircuits from './components/FloatingCircuits';
import ServicesBreadcrumb from '../../components/ui/ServicesBreadcrumb';


const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pageVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const sectionVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <div className="min-h-screen bg-background overflow-hidden">
      {/* Navigation */}
      <NavigationBar />
      <FloatingNavigation />
      {/* Floating Background Elements */}
      <FloatingCircuits />
      {/* Breadcrumb */}
      <div className="relative z-10 pt-16 lg:pt-20">
        <ServicesBreadcrumb 
          serviceCategory="Contact" 
          serviceName="Get in Touch"
        />
      </div>
      {/* Hero Section */}
      <section id="hero" className="relative z-10 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto container-responsive text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-responsive-xl font-bold text-foreground mb-6">
              Get In Touch
            </h1>
            <p className="text-responsive-md text-text-secondary max-w-2xl mx-auto">
              Ready to transform your business? Let's discuss your project and explore how our expertise can drive your success.
            </p>
          </motion.div>
        </div>
      </section>
      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto container-responsive py-16">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Contact Form - 8 columns */}
          <div className="lg:col-span-8">
            <section id="form">
              <ContactForm />
            </section>
          </div>
          
          {/* Contact Information - 4 columns */}
          <div className="lg:col-span-4">
            <section id="info">
              <ContactInfo />
            </section>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="relative z-10 border-t border-border bg-background/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <p className="text-muted-foreground text-sm">
              © {new Date()?.getFullYear()} DARAJA.LABS. All rights reserved. 
              Bridging the gap to your digital future.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;